import { ApexOptions } from 'apexcharts';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

interface IProps {
  options?: ApexOptions;
  series: number[];
}

const DonutChart = ({ options = {}, series }: IProps) => {
  const [seriesState, setSeries] = useState(series);
  const [optionsState, setOptions] = useState(options);

  useEffect(() => {
    setSeries(series);
    setOptions(options);
  }, [series, options]);

  return <Chart options={optionsState} series={seriesState} type='donut' width='380' />;
};

export default DonutChart;
